import { render, staticRenderFns } from "./UserConfigTable.vue?vue&type=template&id=8d57e9f8"
import script from "./UserConfigTable.vue?vue&type=script&lang=js"
export * from "./UserConfigTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports